import React, {Component} from 'react';
import Footer from './Footer';
import TopNavigation from './TopNavigation';
import Axios from 'axios';
import SubPeopleMatching from '../components/Subcomponents/PeopleMatching';
import withRouter from '../components/Functions/WithRouter';

class ProfilesPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
          orgCode: null
        }
    }

    componentDidMount() {
      //see if user is logged in
      console.log('profiles page just mounted')
      window.scrollTo(0, 0)
      document.body.style.backgroundColor = "#fff";

      let { orgCode, accountCode, id } = this.props.params

      let noOrgCode = false
      if (!orgCode) {
        noOrgCode = true
      }
      this.setState({ orgCode, noOrgCode, accountCode, id, ready: true })

      if (orgCode) {
        Axios.get('/api/org', { params: { orgCode } })
        .then((response) => {
          console.log('Org info query attempted', response.data);

            if (response.data.success) {
              console.log('org info query worked')

              const orgName = response.data.orgInfo.orgName
              const orgLogo = response.data.orgInfo.webLogoURIColor
              this.setState({ orgName, orgLogo });

            } else {
              console.log('org info query did not work', response.data.message)
            }

        }).catch((error) => {
            console.log('Org info query did not work for some reason', error);
        });
      } else if (accountCode) {
        Axios.get('/api/account', { params: { accountCode } })
        .then((response) => {
          console.log('Account info query attempted within sub settings', response.data);

          if (response.data.success) {
            console.log('account info query worked in sub settings')

            const employerName = response.data.accountInfo.employerName
            const employerLogoPath = response.data.accountInfo.employerLogoURI

            this.setState({ employerName, employerLogoPath });
          }

        }).catch((error) => {
          console.log('Account info query did not work for some reason', error);
        });
      }
    }

    componentWillUnmount(){
    }

    render() {

        return (
            <div>
              <TopNavigation currentPage={"profilesPage"} darkBackground={true} activeOrg={this.state.orgCode}/>

              <section className="section-features">
                <div className="row">
                  <SubPeopleMatching history={this.props.navigate} orgCode={this.state.orgCode} noOrgCode={this.state.noOrgCode}
                    userType="Peers" pageSource="landingPage"
                  />
                </div>
              </section>

              {/*Footer()*/}
              <Footer history={this.props.navigate} />
            </div>
        )
    }
}

export default withRouter(ProfilesPage);
